import { useAuth } from '../AuthContext';

const AuthErrorBanner = () => {
  const { authError } = useAuth();
  if (!authError) return null;

  return (
    <div style={{ backgroundColor: '#ffe0e0', color: '#900', padding: '10px' }}>
      {authError}
    </div>
  );
}
export default AuthErrorBanner;